/**
 * @file components/shared/GuestBanner.jsx
 * @description Soft, dismissible banner prompting guest users to sign in.
 */

import { LogIn, X } from "lucide-react";
import { useState } from "react";

export function GuestBanner({ onShowAuth }) {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="relative mb-6 px-4 py-3 rounded-2xl bg-brand-green/10 border border-brand-green/20">
      <button
        onClick={() => setDismissed(true)}
        className="absolute top-2 right-2 p-1 rounded-full text-gray-500 hover:text-white transition-colors"
      >
        <X size={14} />
      </button>
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-xl bg-brand-green/20">
          <LogIn size={16} className="text-brand-green" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-white font-medium">
            You're in guest mode
          </p>
          <p className="text-xs text-gray-400 leading-relaxed">
            Sign in to sync your data across devices and unlock personalized insights.
          </p>
        </div>
        <button
          onClick={onShowAuth}
          style={{ touchAction: "manipulation" }}
          className="shrink-0 px-4 py-2 rounded-xl bg-brand-green text-brand-bg text-xs font-bold uppercase tracking-wider active:scale-[0.97] transition-all"
        >
          Sign in
        </button>
      </div>
    </div>
  );
}
